document.documentElement.classList.add('js-reveal');
(function(){
  function ready(fn){ if(document.readyState!=='loading'){fn()}else{document.addEventListener('DOMContentLoaded',fn)} }
  ready(function(){
    // scroll reveal with fail-safes: content must never stay hidden
    var els=document.querySelectorAll('.o3-card,.o3-pillar');
    var showAll=function(){ els.forEach(function(e){ e.classList.add('in-view') }) };
    if(!('IntersectionObserver' in window)){ showAll(); }
    else{
      var io=new IntersectionObserver(function(en){
        en.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in-view'); io.unobserve(e.target) } })
      },{threshold:0,rootMargin:'0px 0px -8% 0px'});
      els.forEach(function(e){ io.observe(e) });
      window.addEventListener('load',function(){ setTimeout(showAll,1200) });
      setTimeout(showAll,2500);
    }
    // product card colour swatches
    document.querySelectorAll('[data-o3-cardswatches]').forEach(function(group){
      var card=group.closest('.o3-card');
      var img=card && card.querySelector('[data-o3-cardimg]');
      group.querySelectorAll('.o3-dot').forEach(function(dot){
        dot.addEventListener('click',function(){
          group.querySelectorAll('.o3-dot').forEach(function(d){ d.classList.remove('is-active') });
          dot.classList.add('is-active');
          if(img && dot.dataset.img){ img.src=dot.dataset.img }
        });
      });
    });
  });
})();
